



export const matchAll = ( str, regexp ) => {
	const matches = [];
	str.replace( regexp, function () {
		const arr = ([]).slice.call( arguments, 0 );
		const extras = arr.splice(-2);
		arr.index = extras[0];
		arr.input = extras[1];
		matches.push(arr);
	});
	return matches.length ? matches : null;
};

